// export const geoJsonFilePath = 'data/qld_sa4s.geo.json';
// export const hhsDataFilePath = 'data/hhs-data.json';
// export const dataFilePath = 'data/edu_data.json';
export const scriptExtBaseEndpoint =
  process.env.REACT_APP_SCRIPT_EXT_BASE_ENDPOINT;

export const geoJsonFilePath = 'qld_sa4s.geo.json';
export const dataFilePath = 'edu_data.json';

export const env =
  process.env.BRANCH != null && `${process.env.BRANCH}`.indexOf('staging') > -1
    ? 'staging'
    : process.env.NODE_ENV;

export const scriptInjectedFn = {
  _grant_hydrate: () => {},
  getDataFileEndpoint: () => {},
};



// WEBPACK FOOTER //
// ./src/config/index.js